import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredList = articles.filter((a) => a.featured).slice(0, 6);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 font-bold">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              不容错过的精彩内容，仙尊亲自推荐
            </p>
          </div>
          <Link
            to="/category/latest"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredList.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading text-foreground-900 font-semibold mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-calendar-line text-xs"></i>
                      {article.publishDate}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line text-xs"></i>
                      {(article.readCount / 10000).toFixed(1)}万
                    </span>
                  </div>
                  <div className="flex items-center gap-1 text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                    <span className="text-xs">阅读</span>
                    <i className="ri-arrow-right-line text-xs"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}